import React from 'react'
import AddInstrumentPopup from '../AddTeacherModal/AddInstrumentsPopup/AddInstrumentsPopup'
import axios from 'axios'
import './student-input.css'
import { baseUrl } from '../assets/Animations'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

export function StudentInput(props) {

    const [instPopup, setInstPopup] = React.useState(false)
    const [stateInstrumentList, setStateInstrumentList] = React.useState(props.student.instrumentList)
    const [stateTeacherList, setStateTeacherList] = React.useState([])

    React.useEffect(() => {
        if(!props.student.instrumentList) {
            props.editStudentInfo(props.index, '', [], 'new-instrument')
        } else {
            props.editStudentInfo(props.index, '', stateInstrumentList, 'new-instrument')
        }
    }, [stateInstrumentList])

    React.useEffect(() => {
        generateTeacherFilterList()
        setTheValue()
    }, [])

    function generateTeacherFilterList() {
        let theSchool = props.theSchool
        let myArray = props.teachers
        let correctTeacherList = []
        if(theSchool === "") {
            correctTeacherList = props.teachers
        } else if (theSchool === "MMA") {
            correctTeacherList = []
            for(let i = 0; i < myArray.length; i++) {
                if(myArray[i].School === 'mma') {
                    correctTeacherList.push(myArray[i])
                }
            }
        } else if (theSchool === "LSMA") {
            correctTeacherList = []
            for(let i = 0; i < myArray.length; i++) {
                if(myArray[i].School === 'lsma') {
                    correctTeacherList.push(myArray[i])
                }
            }
        } else if (theSchool === "TMA") {
            correctTeacherList = []
            for(let i = 0; i < myArray.length; i++) {
                if(myArray[i].School === 'tma') {
                    correctTeacherList.push(myArray[i])
                }
            }
        } else if (theSchool === "MOR") {
            correctTeacherList = []
            for(let i = 0; i < myArray.length; i++) {
                if(myArray[i].School === 'mor') {
                    correctTeacherList.push(myArray[i])
                }
            }
        } else if (theSchool === "PSMA") {
            correctTeacherList = []
            for(let i = 0; i < myArray.length; i++) {
                if(myArray[i].School === 'psma') {
                    correctTeacherList.push(myArray[i])
                }
            }
        } else if (theSchool === "TEM") {
            correctTeacherList = []
            for(let i = 0; i < myArray.length; i++) {
                if(myArray[i].School === 'tem') {
                    correctTeacherList.push(myArray[i])
                }
            }
        } else if (theSchool === "DEN") {
            correctTeacherList = []
            for(let i = 0; i < myArray.length; i++) {
                if(myArray[i].School === 'den') {
                    correctTeacherList.push(myArray[i])
                }
            }
        } else if (theSchool === "TUL") {
            correctTeacherList = []
            for(let i = 0; i < myArray.length; i++) {
                if(myArray[i].School === 'tul') {
                    correctTeacherList.push(myArray[i])
                }
            }
        }
         else {
            correctTeacherList = []
            for(let i = 0; i < myArray.length; i++) {
                if(myArray[i].School === 'glma') {
                    correctTeacherList.push(myArray[i])
                }
            }
        }
        let filteredTeachers = correctTeacherList
        setStateTeacherList(filteredTeachers)
        // let theList = document.getElementById(`new-student-teacher-selector-` + props.student.studentId)
        // while(theList.hasChildNodes()) {
        //     theList.removeChild(theList.lastChild)
        // }
        // let theDefaultOption = document.createElement("option")
        // theDefaultOption.value = "ALL"
        // theDefaultOption.text = "---"
        // theList.appendChild(theDefaultOption)
        // for(let i = 0; i < filteredTeachers.length; i++) {
        //     let option = document.createElement("option")
        //     option.value = filteredTeachers[i].TeacherID
        //     option.text = filteredTeachers[i].Name
        //     theList.appendChild(option)
        // }
    }
    function setTheValue() {
        document.getElementById(`new-student-teacher-selector-` + props.student.studentId).value = props.student.teachersId
    }

    // const setListOfInstruments = (theList) => {
    //     props.editStudentInfo(props.index, '', theList, 'new-instrument')
    // }

    const changeStudentStatusAndSendToSlack = (index, value) => {
        if(value === 'Waitlist' && props.student.studentStatus !== 'Waitlist') {
            axios.post(`${baseUrl}/waitlists/student/${props.student.studentId}`, myHeader)
            .then((res) => { console.log(res) })
            .catch((err) => { console.log(err) })
        } else if (props.student.studentStatus === 'Waitlist' && value !== 'Waitlist') {
            axios.put(`${baseUrl}/waitlists/student/${props.student.studentId}`, {exitStatus: value}, myHeader)
            .then((res) => { console.log(res) })
            .catch((err) => { console.log(err) })
        }
        let message = `*${props.student.studentName} ${props.family.familyName}* has been changed from *${props.student.studentStatus}* to *${value}*`
        axios.post(`${baseUrl}/atharo-slack/${props.family.school.toLowerCase()}`, {message: message}, myHeader)
        props.editStudentInfo(index, `studentStatus`, value, "student-info")
    }

    return(
            <div className="whole-student-input-section" style={props.student.studentStatus === 'Scholarship' ? {padding: '0px 20px', border: "10px solid rgba(255, 166, 0, 0.8)"} : {padding: '10px 30px', border: 'none'}} >
                {instPopup && <AddInstrumentPopup setInstPopup={setInstPopup} listOfInstruments={stateInstrumentList} setListOfInstruments={setStateInstrumentList} studentModal={true} />}
                <div className="student-input__header-wrapper">
                    <div className="input-row__left-side-wrapper">
                        <div className="student-input__student-name-header">{props.student.studentName}</div>
                    </div>
                    <div className="input-row__right-side-wrapper">
                        <select className="student-input__student-status" id="status-filter" onChange={(e) => changeStudentStatusAndSendToSlack(props.index, e.target.value)} value={props.student.studentStatus}>
                            <option value="---" default>Status</option>
                            <option value="Active" default>Active</option>
                            <option value="Being Onboarded">Being Onboarded</option>
                            {/* <option value="Prospective">Prospective</option> */}
                            <option value="Waitlist">Waitlist</option>
                            <option value="Taking a Break">Taking a Break</option>
                            <option value="Summer Break">Summer Break</option>
                            <option value="Follow Up">Follow Up</option>
                            <option value="Scholarship">Scholarship</option>
                            <option value="Needs New Teacher">Needs New Teacher</option>
                            <option value="Left the School">Left the School</option>
                            <option value="Left For Now">Left For Now</option>
                            <option value="Left Permanently">Left - Permanently</option>
                            <option value="Inquired">Inquired</option>
                            <option value="Out of Range">Out of Range</option>
                        </select>
                    </div>
                </div>
                <div className='student-xp-wrapper'>
                    <div className="student-input__student-experience-level">Starting Level: {props.student.experienceLevel ? props.student.experienceLevel : 'Check Email Backup Info'}</div>
                </div>
                <div className="student-input__input-row">
                    <div className="input-row__left-side-wrapper">
                        <div className="input-label">Student's Name</div>
                        <input className="student-modal-firstname" onChange={(e) => props.editStudentInfo(props.index, `studentName`, e.target.value, "student-info")} value={props.student.studentName}/>
                    </div>
                    <div className="input-row__right-side-wrapper">
                        <div className="input-label">DOB</div>
                        <input className="student-modal-firstname" onChange={(e) => props.editStudentInfo(props.index, `dob`, e.target.value, "student-info")} value={props.student.dob} />
                    </div>
                </div>
                <div className="student-input__input-row">
                    <div className="input-row__left-side-wrapper">
                        {/* <div className="input-label">Instrument</div>
                        <input className="student-modal-firstname" onChange={(e) => props.editStudentInfo(props.index, `instrument`, e.target.value, "student-info")} value={props.student.instrument}/> */}
                        <div className="student-input__input-row">
                            <div className="input-label">Instruments</div>
                            <div className='student-input__list-of-instruments'>
                                {props.student.instrumentList && props.student.instrumentList.map((inst, index) => (
                                    <div key={index} className='student-input__each-instrument'>{inst.name}</div>
                                ))}
                            </div>
                            <div className='student-input__new-instrument-input' onClick={() => setInstPopup(true)}>Edit Insts</div>
                        </div>
                    </div>
                    <div className="input-row__right-side-wrapper">
                        <div className="input-label">Lesson Length (Minutes)</div>
                        <input className="student-modal-firstname" onChange={(e) => props.editStudentInfo(props.index, `lessonLength`, e.target.value, "student-info")} value={props.student.lessonLength}/>
                    </div>
                </div>
                <div className="student-input__input-row">
                    <div className="input-row__left-side-wrapper">
                        <div className="input-label">Teacher</div>
                        <select value={props.student.teachersId} className="student-modal-firstname student-modal__teacher-selector" id={`new-student-teacher-selector-` + props.student.studentId} onChange={(e) => props.editStudentInfo(props.index, `teachersId`, e.target.value, "student-info")}>
                            <option value="---" default>Select Teacher</option>
                            {stateTeacherList.map((teacher, index) => (
                                <option key={index} value={teacher.TeacherID}>{teacher.Name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="input-row__right-side-wrapper">
                        <div className="input-label split-it-into-quarters">15 Price</div>
                        <div className="input-label split-it-into-quarters">30 Price</div>
                        <div className="input-label split-it-into-quarters">45 Price</div>
                        <div className="input-label split-it-into-quarters">60 Price</div>
                        <input className="student-modal-firstname four-part-entry" onChange={(e) => props.editStudentInfo(props.index, `15`, e.target.value, "allRates")} value={props.student.allRates[15]}/>
                        <input className="student-modal-firstname four-part-entry" onChange={(e) => props.editStudentInfo(props.index, `30`, e.target.value, "allRates")} value={props.student.allRates[30]}/>
                        <input className="student-modal-firstname four-part-entry" onChange={(e) => props.editStudentInfo(props.index, `45`, e.target.value, "allRates")} value={props.student.allRates[45]}/>
                        <input className="student-modal-firstname four-part-entry" onChange={(e) => props.editStudentInfo(props.index, `60`, e.target.value, "allRates")} value={props.student.allRates[60]}/>
                    </div>
                </div>
 
                <div className="student-input__input-row">
                    <div className="input-row__whole-width-wrapper">
                        <div className="input-label">Notes</div>
                        <textarea className="new-student-notes" onChange={(e) => props.editStudentInfo(props.index, `studentNotes`, e.target.value, "student-info")} value={props.student.studentNotes}/>
                    </div>
                </div>
                {/* <div className="student-input__input-row">
                    <div className="input-label">New Instruments</div>
                    <div onClick={() => setInstPopup(true)}>+ Instrument</div>
                    {props.student.instrumentList && props.student.instrumentList.map((inst) => (
                        <div>{inst.name}</div>
                    ))}
                </div> */}
                    <div className="trashcan-wrapper">
                        <div className="remove-this-student" onClick={() => props.removeAStudent(props.student.studentId)}></div>
                    </div>
                    <div className="new-student-line"></div>
            </div>
        )
}